<script>
  import * as restfulService from '../../../../../services/restfulService'
  import dataService from '../../../../../services/dataService'
  import * as MESSAGES from '../../../../../messages'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'
  import {mapGetters, mapActions} from 'vuex'

  import {clone, cloneDeep} from 'lodash'
  import {required} from 'vuelidate/lib/validators'

  const formacaoObj = {
    id: null,
    ref_pessoa: '',
    ref_grau_instrucao: '',
    ref_instituicao: '',
    descricao: '',
    dt_inicial: '',
    dt_final: '',
    mes_inicial: '',
    ano_inicial: '',
    mes_final: '',
    ano_final: ''
  }

  const experienciaObj = {
    id: null,
    ref_pessoa: '',
    ref_area_atuacao: '',
    empresa: '',
    cargo: '',
    descricao: '',
    dt_inicial: '',
    dt_final: '',
    mes_inicial: '',
    ano_inicial: '',
    mes_final: '',
    ano_final: ''
  }

  export default {
    mixins: [helpers],
    props: ['dados'],
    data () {
      return {
        botaoClicado: false,
        buscandoInstituicoes: false,
        buscandoAreasAtuacao: false,
        buscarInstituicao: null,
        buscarAreaAtuacao: null,
        mostrarModalFormacao: false,
        mostrarModalExperiencia: false,
        data: {
          pessoa_fisica: {
            ref_pessoa: '',
            formacao_academica: [],
            experiencias_profissionais: []
          },
          formacao_academica: Object.assign({}, formacaoObj),
          experiencia_profissional: Object.assign({}, experienciaObj)
        },
        dependencias: {
          instituicoes: [],
          grau_instrucoes: [],
          areas_atuacao: [],
          areas_atuacao_filtrada: [],
          meses: [],
          anos: []
        }
      }
    },
    validations: {
      data: {
        formacao_academica: {
          ref_grau_instrucao: {required},
          ref_instituicao: {required},
          descricao: {required},
          mes_inicial: {required},
          ano_inicial: {required}
        },
        experiencia_profissional: {
          ref_area_atuacao: {required},
          empresa: {required},
          cargo: {required},
          mes_inicial: {required},
          ano_inicial: {required}
        }
      }
    },
    computed: {
      ...mapGetters(['currentUser']),
      formacaoRefGrauInstrucaoErros () {
        const erros = []
        if (!this.$v.data.formacao_academica.ref_grau_instrucao.$dirty) return erros
        !this.$v.data.formacao_academica.ref_grau_instrucao.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      formacaoRefInstituicaoErros () {
        const erros = []
        if (!this.$v.data.formacao_academica.ref_instituicao.$dirty) return erros
        !this.$v.data.formacao_academica.ref_instituicao.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      formacaoDescricaoErros () {
        const erros = []
        if (!this.$v.data.formacao_academica.descricao.$dirty) return erros
        !this.$v.data.formacao_academica.descricao.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      formacaoMesInicialErros () {
        const erros = []
        if (!this.$v.data.formacao_academica.mes_inicial.$dirty) return erros
        !this.$v.data.formacao_academica.mes_inicial.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      formacaoAnoInicialErros () {
        const erros = []
        if (!this.$v.data.formacao_academica.ano_inicial.$dirty) return erros
        !this.$v.data.formacao_academica.ano_inicial.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      experienciaRefAreaAtuacaoErros () {
        const erros = []
        if (!this.$v.data.experiencia_profissional.ref_area_atuacao.$dirty) return erros
        !this.$v.data.experiencia_profissional.ref_area_atuacao.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      experienciaEmpresaErros () {
        const erros = []
        if (!this.$v.data.experiencia_profissional.empresa.$dirty) return erros
        !this.$v.data.experiencia_profissional.empresa.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      experienciaCargoErros () {
        const erros = []
        if (!this.$v.data.experiencia_profissional.cargo.$dirty) return erros
        !this.$v.data.experiencia_profissional.cargo.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      experienciaMesInicialErros () {
        const erros = []
        if (!this.$v.data.experiencia_profissional.mes_inicial.$dirty) return erros
        !this.$v.data.experiencia_profissional.mes_inicial.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      experienciaAnoInicialErros () {
        const erros = []
        if (!this.$v.data.experiencia_profissional.ano_inicial.$dirty) return erros
        !this.$v.data.experiencia_profissional.ano_inicial.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      listaExperiencieProfissional () {
        return this.data.pessoa_fisica.experiencias_profissionais.sort((a, b) => {
          return a.dt_final < b.dt_final
        })
      },
      listaFormacaoAcademica () {
        return this.data.pessoa_fisica.formacao_academica.sort((a, b) => {
          return a.dt_final < b.dt_final
        })
      }
    },
    mounted () {
      this.getDependencies().then(() => {
        this.data.pessoa_fisica = {...this.data.pessoa_fisica, ...this.dados.pessoa_fisica}
      })
    },
    watch: {
      buscarInstituicao: function (query) {
        if (!this.data.formacao_academica.ref_instituicao) {
          this.buscarInstituicoes(query)
        }
      },
      buscarAreaAtuacao: function (query) {
        if (!this.data.experiencia_profissional.ref_area_atuacao) {
          this.buscandoAreasAtuacao = true
          if (query) {
            this.dependencias.areas_atuacao_filtrada = this.dependencias.areas_atuacao.filter(item => {
              return item.descricao.toLowerCase().includes(query.toLowerCase())
            })
            this.buscandoAreasAtuacao = false
          } else {
            this.dependencias.areas_atuacao_filtrada = [...[], ...this.dependencias.areas_atuacao]
            this.buscandoAreasAtuacao = false
          }
        }
      }
    },
    methods: {
      ...mapActions(['showNotification']),
      getDependencies () {
        return new Promise(resolve => {
          dataService.get([
            {domain: 'grau_instrucao'},
            {domain: 'mes'},
            {domain: 'ano'},
            {domain: 'area_atuacao'}
          ]).then((result) => {
            this.dependencias = {...this.dependencias, ...result}
            this.dependencias.areas_atuacao_filtrada = [...[], ...this.dependencias.areas_atuacao]
            resolve()
          })
        })
      },
      buscarInstituicoes (query) {
        return new Promise((resolve, reject) => {
          if (query !== null && query !== '') {
            this.dependencias.instituicoes.splice(0)
            this.buscandoInstituicoes = true
            let data = {nome: {ilike: '%' + query + '%'}}
            restfulService.search('instituicao', null, data)
              .then((response) => {
                this.dependencias.instituicoes.splice(0)
                this.dependencias.instituicoes = [...this.dependencias.instituicoes, ...response.data]
                this.buscandoInstituicoes = false
                resolve()
              })
              .catch(e => {
                console.log(e)
                this.buscandoInstituicoes = false
                reject()
              })
          } else {
            resolve()
          }
        })
      },
      novaExperiencia () {
        this.limparExperiencia()
        this.mostrarModalExperiencia = true
      },
      editarExperiencia (item) {
        this.limparExperiencia()
        this.data.experiencia_profissional = cloneDeep(item)
        let dtInicial = this.data.experiencia_profissional.inicio.split('/')
        this.data.experiencia_profissional.mes_inicial = dtInicial[0]
        this.data.experiencia_profissional.ano_inicial = dtInicial[1]
        delete this.data.experiencia_profissional.dt_inicial
        if (this.data.experiencia_profissional.fim) {
          let dtFinal = this.data.experiencia_profissional.fim.split('/')
          this.data.experiencia_profissional.mes_final = dtFinal[0]
          this.data.experiencia_profissional.ano_final = dtFinal[1]
          delete this.data.experiencia_profissional.dt_final
        }
        this.dependencias.areas_atuacao.splice(0)
        this.dependencias.areas_atuacao.push(this.data.experiencia_profissional.area_atuacao)
        this.mostrarModalExperiencia = true
      },
      limparExperiencia () {
        this.data.experiencia_profissional = Object.assign({}, experienciaObj)
        this.$v.data.experiencia_profissional.$reset()
      },
      salvarExperiencia () {
        this.botaoClicado = true
        bus.$emit('show-loader')
        let data = clone(this.data.experiencia_profissional)
        data.ref_pessoa = this.currentUser.ref_pessoa
        data.dt_inicial = data.ano_inicial + '-' + data.mes_inicial + '-01'
        if (data.mes_final && data.ano_final) {
          data.dt_final = data.ano_final + '-' + data.mes_final + '-01'
        }
        delete data.mes_inicial
        delete data.ano_inicial
        delete data.mes_final
        delete data.ano_final
        restfulService.save('pessoa_fisica_experiencia_profissional', null, null, data)
          .then(response => {
            this.showNotification({
              message: 'Seus dados foram salvos'
            })
            let areaAtuacao = this.dependencias.areas_atuacao.find(item => item.id === response.ref_area_atuacao)
            response.area_atuacao = areaAtuacao
            if (!data.id) {
              this.data.pessoa_fisica.experiencias_profissionais.push(response)
            } else {
              let experienciaProfissionalIndex = this.data.pessoa_fisica.experiencias_profissionais.findIndex(item => item.id === data.id)
              this.data.pessoa_fisica.experiencias_profissionais.splice(experienciaProfissionalIndex, 1, response)
            }
            this.limparExperiencia()
            this.botaoClicado = false
            this.mostrarModalExperiencia = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.botaoClicado = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      removerExperiencia (item) {
        bus.$emit('show-loader')
        restfulService.destroy('pessoa_fisica_experiencia_profissional', null, item.id)
          .then(() => {
            this.showNotification({
              title: 'Dados excluídos',
              message: 'Os dados foram removidos'
            })
            this.data.pessoa_fisica.experiencias_profissionais = this.data.pessoa_fisica.experiencias_profissionais.filter(obj => obj.id !== item.id)
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      novaFormacao () {
        this.limparFormacao()
        this.mostrarModalFormacao = true
      },
      editarFormacao (item) {
        this.limparFormacao()
        this.data.formacao_academica = cloneDeep(item)
        let dtInicial = this.data.formacao_academica.inicio.split('/')
        this.data.formacao_academica.mes_inicial = dtInicial[0]
        this.data.formacao_academica.ano_inicial = dtInicial[1]
        delete this.data.formacao_academica.dt_inicial
        if (this.data.formacao_academica.fim) {
          let dtFinal = this.data.formacao_academica.fim.split('/')
          this.data.formacao_academica.mes_final = dtFinal[0]
          this.data.formacao_academica.ano_final = dtFinal[1]
          delete this.data.formacao_academica.dt_final
        }
        this.dependencias.instituicoes.splice(0)
        this.dependencias.instituicoes.push(this.data.formacao_academica.instituicao)
        this.mostrarModalFormacao = true
      },
      limparFormacao () {
        this.data.formacao_academica = Object.assign({}, formacaoObj)
        this.$v.data.formacao_academica.$reset()
      },
      salvarFormacao () {
        this.botaoClicado = true
        bus.$emit('show-loader')
        let data = clone(this.data.formacao_academica)
        data.ref_pessoa = this.currentUser.ref_pessoa
        data.dt_inicial = data.ano_inicial + '-' + data.mes_inicial + '-01'
        if (data.mes_final && data.ano_final) {
          data.dt_final = data.ano_final + '-' + data.mes_final + '-01'
        }
        delete data.mes_inicial
        delete data.ano_inicial
        delete data.mes_final
        delete data.ano_final
        restfulService.save('pessoa_fisica_formacao_academica', null, null, data)
          .then(response => {
            this.showNotification({
              message: 'Seus dados foram salvos'
            })
            let grauInstrucao = this.dependencias.grau_instrucoes.find(item => item.id === response.ref_grau_instrucao)
            let instituicao = this.dependencias.instituicoes.find(item => item.id === response.ref_instituicao)
            response.grau_instrucao = grauInstrucao
            response.instituicao = instituicao
            if (!data.id) {
              this.data.pessoa_fisica.formacao_academica.push(response)
            } else {
              let formacaoAcademicaIndex = this.data.pessoa_fisica.formacao_academica.findIndex(item => item.id === data.id)
              this.data.pessoa_fisica.formacao_academica.splice(formacaoAcademicaIndex, 1, response)
            }
            this.limparFormacao()
            this.botaoClicado = false
            this.mostrarModalFormacao = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.botaoClicado = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      removerFormacao (item) {
        bus.$emit('show-loader')
        restfulService.destroy('pessoa_fisica_formacao_academica', null, item.id)
          .then(() => {
            this.showNotification({
              title: 'Dados excluídos',
              message: 'Os dados foram removidos'
            })
            this.data.pessoa_fisica.formacao_academica = this.data.pessoa_fisica.formacao_academica.filter(obj => obj.id !== item.id)
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div>
        <h3 class="titulo-atividades flex-header">
            <span>Experiência Profissional</span>
            <v-btn flat small color="success" @click="novaExperiencia">
                <i class="fas fa-plus"></i>
                <span>Adicionar Experiência</span>
            </v-btn>
        </h3>
        <div class="lista-atividades">
            <div class="item-atividade" v-for="item in listaExperiencieProfissional">
                <div class="item-icon">
                    <i class="fas fa-briefcase"></i>
                </div>
                <div class="item-data">
                    <div class="item-titulo">{{item.empresa}} ({{item.cargo}})</div>
                    <div class="item-instituicao">{{item.area_atuacao.nome}}</div>
                    <div class="item-instituicao" v-if="item.descricao">{{item.descricao}}</div>
                    <div class="item-periodo">
                        <span v-if="item.dt_final">
                            {{item.inicio}} - {{item.fim}}
                        </span>
                        <span v-else>
                            Início em {{item.inicio}} - Emprego atual
                        </span>
                    </div>
                </div>
                <div class="item-acoes">
                    <v-btn color="info"
                           fab small outline
                           @click="editarExperiencia(item)"
                           title="Editar item">
                        <i class="fas fa-edit"></i>
                    </v-btn>
                    <v-btn color="error"
                           fab small outline
                           @click="removerExperiencia(item)"
                           title="Excluir item">
                        <i class="fas fa-times"></i>
                    </v-btn>
                </div>
            </div>
        </div>
        <h3 class="titulo-atividades flex-header">
            <span>Formação Acadêmica</span>
            <v-btn flat small color="success" @click="novaFormacao">
                <i class="fas fa-plus"></i>
                <span>Adicionar Formação</span>
            </v-btn>
        </h3>
        <div class="lista-atividades">
            <div class="item-atividade" v-for="item in listaFormacaoAcademica">
                <div class="item-icon">
                    <i class="fas fa-user-graduate"></i>
                </div>
                <div class="item-data">
                    <div class="item-titulo">{{item.descricao}}</div>
                    <div class="item-instituicao">{{item.instituicao.nome}}</div>
                    <div class="item-periodo">
                        <span v-if="item.dt_final">
                            {{item.inicio}} - {{item.fim}}
                        </span>
                        <span v-else>
                            Início em {{item.inicio}} - Em andamento
                        </span>
                    </div>
                </div>
                <div class="item-acoes">
                    <v-btn color="info"
                           fab small outline
                           @click="editarFormacao(item)"
                           title="Editar item">
                        <i class="fas fa-edit"></i>
                    </v-btn>
                    <v-btn color="error"
                           fab small outline
                           @click="removerFormacao(item)"
                           title="Excluir item">
                        <i class="fas fa-times"></i>
                    </v-btn>
                </div>
            </div>
        </div>
        <v-dialog v-model="mostrarModalExperiencia" width="70%">
            <v-card>
                <v-card-title class="primary white--text"
                              >
                    Experiência Profissional
                </v-card-title>
                <v-card-text>
                    <v-container fluid grid-list-md>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-autocomplete v-model="data.experiencia_profissional.ref_area_atuacao"
                                                :error-messages="experienciaRefAreaAtuacaoErros"
                                                @input="$v.data.experiencia_profissional.ref_area_atuacao.$touch()"
                                                @blur="$v.data.experiencia_profissional.ref_area_atuacao.$touch()"
                                                :items="dependencias.areas_atuacao_filtrada"
                                                :loading="buscandoAreasAtuacao"
                                                :search-input.sync="buscarAreaAtuacao"
                                                item-text="descricao"
                                                item-value="id"
                                                label="Área de Atuação"
                                                placeholder="Digite o nome da área de atuação"
                                                no-data-text="Nenhuma registro encontrado"
                                                hide-no-data
                                                hide-selected
                                                clearable/>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="data.experiencia_profissional.empresa"
                                              :error-messages="experienciaEmpresaErros"
                                              @input="$v.data.experiencia_profissional.empresa.$touch()"
                                              @blur="$v.data.experiencia_profissional.empresa.$touch()"
                                              label="Empresa"
                                              required/>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="data.experiencia_profissional.cargo"
                                              :error-messages="experienciaCargoErros"
                                              @input="$v.data.experiencia_profissional.cargo.$touch()"
                                              @blur="$v.data.experiencia_profissional.cargo.$touch()"
                                              label="Cargo"
                                              required/>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="data.experiencia_profissional.descricao"
                                              label="Descrição das atividades exercidas"/>
                            </v-flex>
                            <v-flex sm2 xs4>
                                <v-select :items="dependencias.meses"
                                          v-model="data.experiencia_profissional.mes_inicial"
                                          :error-messages="experienciaMesInicialErros"
                                          @input="$v.data.experiencia_profissional.mes_inicial.$touch()"
                                          @blur="$v.data.experiencia_profissional.mes_inicial.$touch()"
                                          label="Mês Inicial"
                                          single-line
                                          clearable/>
                            </v-flex>
                            <v-flex sm4 xs8>
                                <v-select :items="dependencias.anos"
                                          v-model="data.experiencia_profissional.ano_inicial"
                                          :error-messages="experienciaAnoInicialErros"
                                          @input="$v.data.experiencia_profissional.ano_inicial.$touch()"
                                          @blur="$v.data.experiencia_profissional.ano_inicial.$touch()"
                                          label="Ano Inicial"
                                          single-line
                                          clearable/>
                            </v-flex>
                            <v-flex sm2 xs4>
                                <v-select :items="dependencias.meses"
                                          v-model="data.experiencia_profissional.mes_final"
                                          label="Mês Final"
                                          single-line
                                          clearable/>
                            </v-flex>
                            <v-flex sm4 xs8>
                                <v-select :items="dependencias.anos"
                                          v-model="data.experiencia_profissional.ano_final"
                                          label="Ano Final"
                                          single-line
                                          clearable/>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success"
                           @click="salvarExperiencia"
                           :disabled="botaoClicado || $v.data.experiencia_profissional.$invalid">
                        Salvar Experiência
                    </v-btn>
                    <v-btn flat @click="mostrarModalExperiencia = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="mostrarModalFormacao" width="70%">
            <v-card>
                <v-card-title class="primary white--text"
                              >
                    Formação Acadêmica
                </v-card-title>
                <v-card-text>
                    <v-container fluid grid-list-md>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-select :items="dependencias.grau_instrucoes"
                                          v-model="data.formacao_academica.ref_grau_instrucao"
                                          :error-messages="formacaoRefGrauInstrucaoErros"
                                          @input="$v.data.formacao_academica.ref_grau_instrucao.$touch()"
                                          @blur="$v.data.formacao_academica.ref_grau_instrucao.$touch()"
                                          label="Selecione o nível da formação"
                                          item-text="descricao"
                                          item-value="id"
                                          single-line
                                          clearable/>
                            </v-flex>
                            <v-flex xs12>
                                <v-autocomplete v-model="data.formacao_academica.ref_instituicao"
                                                :error-messages="formacaoRefInstituicaoErros"
                                                @input="$v.data.formacao_academica.ref_instituicao.$touch()"
                                                @blur="$v.data.formacao_academica.ref_instituicao.$touch()"
                                                :items="dependencias.instituicoes"
                                                :loading="buscandoInstituicoes"
                                                :search-input.sync="buscarInstituicao"
                                                item-text="nome"
                                                item-value="id"
                                                label="Instituição"
                                                placeholder="Digite o nome da instituição"
                                                no-data-text="Nenhuma registro encontrado"
                                                hide-no-data
                                                hide-selected
                                                clearable/>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field v-model="data.formacao_academica.descricao"
                                              :error-messages="formacaoDescricaoErros"
                                              @input="$v.data.formacao_academica.descricao.$touch()"
                                              @blur="$v.data.formacao_academica.descricao.$touch()"
                                              label="Curso/Descrição"
                                              required/>
                            </v-flex>
                            <v-flex sm2 xs4>
                                <v-select :items="dependencias.meses"
                                          v-model="data.formacao_academica.mes_inicial"
                                          :error-messages="formacaoMesInicialErros"
                                          @input="$v.data.formacao_academica.mes_inicial.$touch()"
                                          @blur="$v.data.formacao_academica.mes_inicial.$touch()"
                                          label="Mês Inicial"
                                          single-line
                                          clearable/>
                            </v-flex>
                            <v-flex sm4 xs8>
                                <v-select :items="dependencias.anos"
                                          v-model="data.formacao_academica.ano_inicial"
                                          :error-messages="formacaoAnoInicialErros"
                                          @input="$v.data.formacao_academica.ano_inicial.$touch()"
                                          @blur="$v.data.formacao_academica.ano_inicial.$touch()"
                                          label="Ano Inicial"
                                          single-line
                                          clearable/>
                            </v-flex>
                            <v-flex sm2 xs4>
                                <v-select :items="dependencias.meses"
                                          v-model="data.formacao_academica.mes_final"
                                          label="Mês Final"
                                          single-line
                                          clearable/>
                            </v-flex>
                            <v-flex sm4 xs8>
                                <v-select :items="dependencias.anos"
                                          v-model="data.formacao_academica.ano_final"
                                          label="Ano Final"
                                          single-line
                                          clearable/>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success"
                           @click="salvarFormacao"
                           :disabled="botaoClicado || $v.data.formacao_academica.$invalid">
                        Salvar Formação
                    </v-btn>
                    <v-btn flat @click="mostrarModalFormacao = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>



// WEBPACK FOOTER //
// FormacaoEmprego.vue?3ecefaf3